import React from 'react';
import getLabel from '../../services/LinkagesDataLayer/labels';
import formater from "../../services/LinkagesDataLayer/formater";
import LinkagesDataLayerService from "../../services/LinkagesDataLayer/LinkagesDataLayerService";

const styles = {
    rowHead: {
        backgroundColor: `#4d5a31`,
        borderColor: `#4d5a31`,
        color: '#474242 !important',
        borderWidth: '2px',
        borderStyle: 'solid'
    }

}


class DataTable extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            downloading: false
        }
    }

    colTemplate = (rowData, column, index ) => {

        let value = rowData[column.value];

        if( column.value !== 'ano'){
            value = formater(column.value, rowData[column.value]);
        }

        return <td key={index}>{value}</td>;
    }

    exportExcel = async () => {
        try{
            this.setState({downloading: true});
            const requestPayload = this.getDataToExcelExport();

            const response = await axios.post( route('linkages-data-to-excel.export'), requestPayload, {
                responseType: 'blob'
            } );

            const blob = new Blob([response.data]);
            const fileName = response.headers['content-disposition'].split('filename=')[1];

            this.downloadBlob(blob, fileName);

        }catch(e){

        }finally {
            this.setState({downloading:false});
        }

    }

    exportPDF = async () => {
        try{
            this.setState({downloading: true});
            const requestPayload = this.getDataToPDFExport();

            const response = await axios.post( route('linkages-data-to-pdf.export'), requestPayload, {
                responseType: 'blob'
            } );

            const blob = new Blob([response.data]);
            const fileName = response.headers['content-disposition'].split('filename=')[1].replace(/"/g, '');

            this.downloadBlob(blob, fileName);

        }catch(e){

        }finally {
            this.setState({downloading:false});
        }

    }

    getDataToExcelExport() {
        const headers = this.getHeaders().map(header => header.label);

        return {
            headers: headers,
            data: this.props.data,
            nome_camada: this.props.activeDatalayer
        };
    }

    getDataToPDFExport() {
        const headers = this.getHeaders();

        return {
            headers: headers,
            data: this.props.data,
            nome_camada: this.props.activeDatalayer,
            label_nome_camada: LinkagesDataLayerService.getLayerLabel(this.props.activeDatalayer)
        };
    }

    getHeaders() {
        return Object.keys(this.props.data[0]).map(header => {
            return {value: header, label: getLabel(header)}
        });
    }

    downloadBlob(blob, fileName) {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', fileName );
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
    }

    render() {

        const headers = this.getHeaders();

        return (
            <div className="card">
                <div className="card-body">
                    <table className="table table-striped table-bordered">
                        <thead>
                        <tr style={styles.rowHead}>
                            {headers.map( (header, index) => <th style={{color: 'white', fontWeight: 'bold'}}  key={index}>{header.label}</th>)}
                        </tr>
                        </thead>
                        <tbody>
                        {this.props.data.map( ( row, rowIndex ) => {
                            return (
                                <tr key={rowIndex}>
                                    {headers.map( (header, colIndex) => this.colTemplate( row, header, colIndex ) )}
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
                <div className="card-footer" style={{gap: '10px', display: 'flex', justifyContent: 'flex-end'}}>
                    <button className="btn btn-default pull-right"
                            disabled={this.state.downloading}
                            onClick={this.exportExcel}>
                        Exportar Excel &nbsp;
                        <i className="fas fa-file-excel"></i>
                        &nbsp;
                        {this.state.downloading && <i className="fas fa-spinner fa-spin"></i>}

                    </button>

                    <button className="btn btn-default pull-right"
                            disabled={this.state.downloading}
                            onClick={this.exportPDF}>
                        Exportar PDF &nbsp;
                        <i className="fas fa-file-pdf"></i>
                        &nbsp;
                        {this.state.downloading && <i className="fas fa-spinner fa-spin"></i>}

                    </button>
                </div>
            </div>
        );
    }


}

export default DataTable;
